import Material from "../Materials"

const doorOffsets = 2.5 //centimeters

export default 
function DoorBorders(params) {

  const positions = {
    "a":[ params.dim[1]/2,  params.dim[2]/2,  params.dim[0]/2-params.structuresize/2 ],
    "b":[ params.dim[1]-params.structuresize/2,  params.dim[2]/2,  0 ],  
    "c":[ params.dim[1]/2,  params.dim[2]/2, -params.dim[0]/2+params.structuresize/2]
  }
  const rotations = {
    "a":[ 0,  Math.PI/2,  0 ],  //A position
    "b":[ 0,  0, 0 ],
    "c":[ 0,  -Math.PI/2, 0 ]
  }

  const doorWidth = (["a","c"].includes(params.side)?params.dim[1]:params.dim[0])/2-doorOffsets-params.structuresize

  return (
    <group 
      position={positions[params.side]}
      rotation={rotations[params.side]}
      item={`doorborders-${params.side}`}
    >
      <mesh 
        item='montante-sx'
        castShadow
        receiveShadow
        position={[ 0, -(params.dim[2]-params.doorheight)/2, doorWidth-params.structuresize/2+doorOffsets/2 ]}
      >
        <Material material={params.material} type={params.type} texture={params.texture} /> 
        <boxGeometry args={[params.structuresize, params.doorheight-2*params.structuresize, params.structuresize]} />
      </mesh>
      <mesh 
        item='up-sx'
        castShadow
        receiveShadow
        position={[ 0, -params.dim[2]/2+params.doorheight-params.structuresize/2, doorWidth/2+doorOffsets/2 ]}
      >
        <Material material={params.material} type={params.type} texture={params.texture} /> 
        <boxGeometry args={[params.structuresize, params.structuresize, doorWidth]} />
      </mesh>

      <mesh 
        item='down-sx'
        castShadow
        receiveShadow
        position={[ 0, -params.dim[2]/2+params.structuresize/2, doorWidth/2+doorOffsets/2 ]}
      >
        <Material material={params.material} type={params.type} texture={params.texture} /> 
        <boxGeometry args={[params.structuresize, params.structuresize, doorWidth]} />
      </mesh>

      <mesh  
        item='montante-dx'
        castShadow
        receiveShadow
        position={[0,-(params.dim[2]-params.doorheight)/2,-doorWidth+params.structuresize/2-doorOffsets/2]}>
        <Material material={params.material} type='color' texture={params.texture} /> 
        <boxGeometry args={[params.structuresize,params.doorheight-2*params.structuresize, params.structuresize]} />
      </mesh>

      <mesh 
        item='up-dx'
        castShadow
        receiveShadow
        position={[ 0, -params.dim[2]/2+params.doorheight-params.structuresize/2, -doorWidth/2-doorOffsets/2 ]}
      >
        <Material material={params.material} type={params.type} texture={params.texture} /> 
        <boxGeometry args={[params.structuresize, params.structuresize, doorWidth]} />
      </mesh>

      <mesh 
        item='down-dx'
        castShadow
        receiveShadow
        position={[ 0, -params.dim[2]/2+params.structuresize/2, -doorWidth/2-doorOffsets/2 ]}
      >
        <Material material={params.material} type={params.type} texture={params.texture} /> 
        <boxGeometry args={[params.structuresize, params.structuresize, doorWidth]} />
      </mesh>

    </group>
  )
}
